import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { useToast } from '../../../controller/ToastController';
import StoreController, {
  CurrentStoreContext,
  StaffType,
} from '../../../controller/StoreController';
import CustomTable from '../../../components/Table';
import AddStaffModal from '../../../components/modal/AddStaffModal';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import { useOutletContext } from 'react-router-dom';

const StaffSetting = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [staffList, setStaffList] = useState<StaffType[]>([]);
  const [selectedStaff, setSelectedStaff] = useState<StaffType | null>(null);
  const dayMap = ['일 ', '월 ', '화 ', '수 ', '목 ', '금 ', '토 '];
  const tableProductHeader = ['', '이름', '근무요일', '근무시간', '전화번호', '', ''];
  const [selectEmployeeId, setSelectEmployeeId] = useState<number | null>(null);
  const [addStaffModal, setAddStaffModal] = useState<boolean>(false);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const editList = (data: StaffType) => {
    setSelectedStaff(data);
    setAddStaffModal(true);
  };
  const deleteClick = (employeeId: number) => {
    setSelectEmployeeId(employeeId);
    setVisibleConfirm(true);
  };
  const confirmDelete = () => {
    if (selectEmployeeId !== null) {
      delEmployee(selectEmployeeId);
    }
    setVisibleConfirm(false);
    getConciergeList();
  };

  const renderStaffList = () => {
    return (
      <>
        {staffList.map((data, index: number) => {
          const workDaysArray = data.work_days.split(',').map((day) => dayMap[parseInt(day)]);
          const startTime = moment(data.start_time, 'HH:mm:ss').format('HH:mm');
          const timeFormatted = moment.duration(data.end_time).asHours();
          const endTime = moment().startOf('day').add(timeFormatted, 'hours').format('HH:mm');
          const isAllDay = startTime === endTime ? '하루 종일' : `${startTime}-${endTime}`;

          return (
            <tr key={data.employee_id} className="webDetailTableWrap">
              <td>{index + 1}</td>
              <td>{data.name}</td>
              <td>{workDaysArray}</td>
              <td>{isAllDay}</td>
              <td>{data.phone_number}</td>
              <td onClick={() => editList(data)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`} alt="수정아이콘" />
              </td>
              <td onClick={() => deleteClick(data.employee_id)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_delete.svg`} alt="삭제아이콘" />
              </td>
            </tr>
          );
        })}
      </>
    );
  };

  const getConciergeList = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };

      const oResponse = await StoreController.getEmployee(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          setStaffList(oRes.data);
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };
  const delEmployee = async (employeeId: number) => {
    try {
      const oParams = {
        employee_id: employeeId,
      };

      const oResponse = await StoreController.delEmployee(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.ok) {
          showToast('삭제되었습니다.');
          getConciergeList();
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  useEffect(() => {
    getConciergeList();
  }, []);

  return (
    <Style>
      <div className="contentContainer">
        <button
          onClick={() => {
            setAddStaffModal(true);
            setSelectedStaff(null);
          }}
          className="addButton flex">
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가 아이콘" />
          <p>새 직원 추가하기</p>
        </button>
        {staffList && staffList.length > 0 ? (
          <CustomTable
            tableHeader={tableProductHeader}
            renderTableItem={renderStaffList}
            type={'radius'}
          />
        ) : (
          <div className="noneList">
            <p>등록된 직원이 없습니다.</p>
          </div>
        )}
      </div>

      <AddStaffModal
        isVisible={addStaffModal}
        setVisible={setAddStaffModal}
        renderStaffList={getConciergeList}
        staffData={selectedStaff}
      />
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={confirmDelete}
      />
    </Style>
  );
};

export default StaffSetting;

const Style = styled.div`
  .flex {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: #555;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    color: #979797;
  }

  /* title */
  .title {
    margin-bottom: 14px;

    h2 {
      margin-bottom: 10px;
    }
  }

  /* addButton */
  .addButton {
    width: 100%;
    justify-content: center;
    gap: 42px;
    margin-bottom: 45px;
    padding: 10px;
    border: 1px solid #4dd2ae;
    border-radius: 5px;

    p {
      font-size: 16px;
      font-weight: 600;
      color: #4dd2ae;
    }
  }

  /* table */
  thead th {
    padding: 12px 0 !important;
  }
  th,
  td {
    border: none;
  }
  td {
    font-size: 14px !important;
    font-weight: 600;
    color: #555;
  }

  .noneList {
    padding: 50px 0;

    p {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
  }

  @media (max-width: 600px) {
    th,
    td {
      font-size: 12px !important;
    }
    .radiusTable tbody td {
      padding: 14px 6px;
    }
    th:nth-child(5),
    td:nth-child(5) {
      display: none;
    }
  }
`;
